import { render, staticRenderFns } from "./UserOfficer.vue?vue&type=template&id=1780d1cc&scoped=true&"
import script from "./UserOfficer.vue?vue&type=script&lang=js&"
export * from "./UserOfficer.vue?vue&type=script&lang=js&"
import style0 from "./UserOfficer.vue?vue&type=style&index=0&id=1780d1cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780d1cc",
  null
  
)

export default component.exports